import { render, staticRenderFns } from "./PemulihanPembayaran.vue?vue&type=template&id=1fe8f978&scoped=true&"
import script from "./PemulihanPembayaran.vue?vue&type=script&lang=js&"
export * from "./PemulihanPembayaran.vue?vue&type=script&lang=js&"
import style0 from "./PemulihanPembayaran.vue?vue&type=style&index=0&id=1fe8f978&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe8f978",
  null
  
)

export default component.exports